import { render, staticRenderFns } from "./list-inside.vue?vue&type=template&id=0851ac2f&scoped=true"
import script from "./list-inside.vue?vue&type=script&lang=js"
export * from "./list-inside.vue?vue&type=script&lang=js"
import style0 from "./list-inside.vue?vue&type=style&index=0&id=0851ac2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851ac2f",
  null
  
)

export default component.exports